import React from "react";
import { Box, SpaceBetween, ColumnLayout } from "@cloudscape-design/components";
import Badge from "../Badge";
import { BadgeColor } from "../../../constants/reportConstants";

interface InfoItem {
  type: "badge" | "text";
  content: string;
  badgeVariant?: "category" | "status";
  badgeColor?: BadgeColor;
}

interface InfoSectionProps {
  items: InfoItem[];
  columns?: number;
}

/**
 * Displays information items in a column layout with support for badges and text
 * @param items - Array of information items to display
 * @param columns - Number of columns for layout
 */
export const InfoSection: React.FC<InfoSectionProps> = ({ 
  items, 
  columns = 2 
}) => (
  <Box>
    <ColumnLayout columns={columns}>
      <Box>
        <SpaceBetween direction="vertical" size="xs">
          {items.map((item, index) => (
            <Box key={index}>
              {item.type === "badge" ? (
                <Badge 
                  variant={item.badgeVariant || "category"} 
                  color={item.badgeColor || BadgeColor.BLUE}
                >
                  {item.content}
                </Badge>
              ) : (
                <Box color="text-body-secondary" fontSize="body-s">
                  {item.content}
                </Box>
              )}
            </Box>
          ))}
        </SpaceBetween>
      </Box>
    </ColumnLayout>
  </Box>
);
